import { style } from 'styled-system';

export const maxWidth = style({
  prop: 'span',
  alias: 'maxWidth',
  cssProperty: 'maxWidth',
  transformValue: (n: number) => `${n * (100 / 24)}%`,
});
